import React from 'react';

function useTimeout(callback: () => void, delay?: number) {
	const callbackRef = React.useRef(callback);

	React.useEffect(() => {
		callbackRef.current = callback;
	}, [callback]);

	React.useEffect(() => {
		let timer;

		if ((delay || 0) > 0 && callback && typeof callback === 'function') {
			timer = setTimeout(callbackRef.current, delay || 0);
		}

		return () => {
			if (timer) {
				clearTimeout(timer);
			}
		};
	}, [callback, delay]);
}

export default useTimeout;
